<template>
<div class="sidebar">
  <TabMenu class="tab-menu" v-model:activeIndex="activeIndex" :model="tabItemsWithCustom"></TabMenu>
  <div class="tabs-wrapper">
    <div class="tabs">
      <PropertiesTab v-if="activeTab === 'properties' && enabledProperties" />
      <ColorCodeTab v-if="activeTab === 'color-code' && enabledColorCode" />
      <IoTTab v-if="activeTab === 'iot' && enabledIot" />
      <PropertiesTab v-if="activeTab === 'custom' && selectedCustomTab" :tab="selectedCustomTab"/>
      </div>
  </div>
</div>
</template>

<script>
import PropertiesTab from './PropertiesTab.vue';
import ColorCodeTab from './ColorCodeTab.vue';
import IoTTab from './IoTTab.vue';

import TabMenu from 'primevue/tabmenu';
import { mapState } from 'vuex';
import { mapGetters } from 'vuex/dist/vuex.cjs.js';
export default {
  name: 'Sidebar',

  computed: {
    ...mapState('settings', ['customTabsConfig']),
    ...mapGetters('settings', ['enabledProperties', 'enabledColorCode', 'enabledIot']),

    selectedCustomTab() {
      if (this.activeTab !== 'custom' || !this.customTabsConfig || !Array.isArray(this.customTabsConfig)) {
        return null;
      }
      return this.customTabsConfig[this.tabItemsWithCustom[this.activeIndex]?.customTabIndex];
    },

    customTabsList() {
      if (!this.customTabsConfig || !Array.isArray(this.customTabsConfig)) {
        return [];
      }
      return this.customTabsConfig;
    },

    activeTab() {
      return this.tabItemsWithCustom[this.activeIndex]?.type;
    },

    tabItemsWithCustom() {
      const tabs = [];
      if (this.enabledProperties) {
        tabs.push({ label: 'Properties', type: 'properties' });
      }
      if (this.enabledColorCode) {
        tabs.push({ label: 'Color Code', type: 'color-code' });
      }
      if (this.enabledIot) {
        tabs.push({ label: 'IoT', type: 'iot' });
      }
      return tabs.concat(
        this.customTabsList.map((tab, index) => ({
          label: tab.name || `Custom Tab ${index + 1}`,
          icon: tab.icon || '',
          type: 'custom',
          customTabIndex: index,
        }))
      );
    }
  },

  components: { TabMenu, PropertiesTab, ColorCodeTab, IoTTab },

  watch: {
    enabledProperties() {
      this.activeIndex = 0;
    },

    enabledColorCode() {
      this.activeIndex = 0;
    },

    enabledIoT() {
      this.activeIndex = 0;
    },

    tabItemsWithCustom() {
      this.activeIndex = 0;
    },
  },

  data() {
    return {
      activeIndex: 0,
    }
  }
}
</script>
<style lang="scss">
.sidebar .tab-menu > ul {
  flex-wrap: wrap !important;
}
</style>
<style lang="scss" scoped>
.sidebar {
  background: var(--surface-a);
  height: calc(100vh - 64px) !important;
  position: relative;

  display: flex;
  flex-direction: column;
  .tabs-wrapper {
    flex: 1;
    position: relative;
  }
  
  .tabs {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 5px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    overflow: auto;
    align-content: flex-start;
    width: 100%;
  }
}
</style>